import uniqBy from 'lodash/uniqBy';
var VIEW_PATCHES = ['view', 'list'];
var MAIN_MENU_TYPES = ['drawer', 'tab'];
var MENU_TYPE = 'navigation';
var NotificationPatchFilter = /** @class */ (function () {
    function NotificationPatchFilter(patchwork) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        this.patchwork = patchwork;
        /**
         * filterPatches is a recursive function which detects all the patches that are directly or indirectly connected to the main menu
         * This recursive function will iterate through n number of levels, till the leaf node of each iteration
         * Because of that, with heavy structures, there might be some performance issues
         * @param patch Patch should have a connection with the main menu in any level
         */
        this.filterPatches = function (patch) {
            var _a;
            if (patch) {
                var outgoingEdges = (_a = _this.edges) === null || _a === void 0 ? void 0 : _a.filter(function (edge) { return (edge === null || edge === void 0 ? void 0 : edge.from_patch) === patch.id; });
                /**
                 * Since this operation has nested loops, it has a time complexity of O(n) which may affect the performance
                 ** A loading mechanism is recommended for such scenario where patch count exceeds even 100
                 */
                outgoingEdges === null || outgoingEdges === void 0 ? void 0 : outgoingEdges.forEach(function (edge) {
                    var _a;
                    var nextPatch = (_a = _this.patches) === null || _a === void 0 ? void 0 : _a.find(function (patch) { return (patch === null || patch === void 0 ? void 0 : patch.id) === (edge === null || edge === void 0 ? void 0 : edge.to_patch); });
                    if (VIEW_PATCHES.includes(nextPatch === null || nextPatch === void 0 ? void 0 : nextPatch.type)) {
                        _this.options.push({
                            id: nextPatch === null || nextPatch === void 0 ? void 0 : nextPatch.id,
                            label: nextPatch === null || nextPatch === void 0 ? void 0 : nextPatch.name,
                            value: nextPatch === null || nextPatch === void 0 ? void 0 : nextPatch.id,
                        });
                    }
                });
            }
            return;
        };
        this.patches = (patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalPatches)
            ? patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalPatches
            : (patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches)
                ? patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches
                : [];
        this.edges = (patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges)
            ? patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges
            : (patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges)
                ? patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges
                : [];
        this.entryPoint = ((_a = this.patchwork) === null || _a === void 0 ? void 0 : _a.originalEntrypoint)
            ? (_b = this.patchwork) === null || _b === void 0 ? void 0 : _b.originalEntrypoint
            : ((_c = this.patchwork) === null || _c === void 0 ? void 0 : _c.entrypoint)
                ? (_d = this.patchwork) === null || _d === void 0 ? void 0 : _d.entrypoint
                : [];
        this.options = [];
        this.entryPatch = (_e = this.patches) === null || _e === void 0 ? void 0 : _e.find(function (patch) { return patch.id === _this.entryPoint; });
    }
    NotificationPatchFilter.prototype.getOptions = function () {
        var _a, _b, _c, _d, _e;
        /**
         * If the entry patch is a list or a view, only the entry patch should appear in the option list
         */
        if (this.entryPatch &&
            VIEW_PATCHES.includes((_a = this.entryPatch) === null || _a === void 0 ? void 0 : _a.type) &&
            ((_b = this.entryPatch) === null || _b === void 0 ? void 0 : _b.name) &&
            ((_c = this.entryPatch) === null || _c === void 0 ? void 0 : _c.id)) {
            this.options.push({
                id: this.entryPatch.id,
                label: this.entryPatch.name,
                value: this.entryPatch.id,
            });
        }
        /**
         * If the entry patch is a main menu, all patches that are connected directly or indirectly should appear in the option list
         */
        if (this.entryPatch &&
            ((_d = this.entryPatch) === null || _d === void 0 ? void 0 : _d.type) === MENU_TYPE &&
            MAIN_MENU_TYPES.includes((_e = this.entryPatch) === null || _e === void 0 ? void 0 : _e.navigation)) {
            this.filterPatches(this.entryPatch);
        }
        return uniqBy(this.options, 'id');
    };
    return NotificationPatchFilter;
}());
export { NotificationPatchFilter };
